import React from 'react'
import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
  style?: React.CSSProperties
  className?: string
  to: string
  title?: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  style = {},
  className = '',
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { app } = config

  return (
    <div className={'menu-item ' + className} style={style}>
      <Link
        className={clsx('menu-link without-sub', { active: isActive })}
        to={to}>
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot" />
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className="menu-icon">
            {' '}
            <KTSVG path={icon} className="svg-icon-2" />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)} />
        )}
        {title && <span className="menu-title">{title}</span>}
        {children}
      </Link>
    </div>
  )
}

export { SidebarMenuItem }
